/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type SearchCoverageQueryVariables = Exact<{
  text: string;
}>;


export type SearchCoverageQuery = { searchSolicitorCloudCoverages: Array<{ fullText: string, pageNumber: number, documentVersion: { id: string, document: { corporation: { id: string, name: string } } } }> };

export type SearchCoverageGetCoverageViewDocumentFileUrlQueryVariables = Exact<{
  ids: Array<string | number> | string | number;
}>;


export type SearchCoverageGetCoverageViewDocumentFileUrlQuery = { solicitorCloudCoverageDocumentVersionByIds: Array<{ fileUrl: string }> };


export const SearchCoverageDocument = gql`
    query SearchCoverage($text: String!) {
  searchSolicitorCloudCoverages(text: $text) {
    fullText
    pageNumber
    documentVersion {
      id
      document {
        corporation {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useSearchCoverageQuery__
 *
 * To run a query within a Vue component, call `useSearchCoverageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCoverageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchCoverageQuery({
 *   text: // value for 'text'
 * });
 */
export function useSearchCoverageQuery(variables: SearchCoverageQueryVariables | VueCompositionApi.Ref<SearchCoverageQueryVariables> | ReactiveFunction<SearchCoverageQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchCoverageQuery, SearchCoverageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchCoverageQuery, SearchCoverageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchCoverageQuery, SearchCoverageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchCoverageQuery, SearchCoverageQueryVariables>(SearchCoverageDocument, variables, options);
}
export function useSearchCoverageLazyQuery(variables?: SearchCoverageQueryVariables | VueCompositionApi.Ref<SearchCoverageQueryVariables> | ReactiveFunction<SearchCoverageQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchCoverageQuery, SearchCoverageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchCoverageQuery, SearchCoverageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchCoverageQuery, SearchCoverageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SearchCoverageQuery, SearchCoverageQueryVariables>(SearchCoverageDocument, variables, options);
}
export type SearchCoverageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchCoverageQuery, SearchCoverageQueryVariables>;
export const SearchCoverageGetCoverageViewDocumentFileUrlDocument = gql`
    query SearchCoverageGetCoverageViewDocumentFileUrl($ids: [ID!]!) {
  solicitorCloudCoverageDocumentVersionByIds(ids: $ids) {
    fileUrl
  }
}
    `;

/**
 * __useSearchCoverageGetCoverageViewDocumentFileUrlQuery__
 *
 * To run a query within a Vue component, call `useSearchCoverageGetCoverageViewDocumentFileUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCoverageGetCoverageViewDocumentFileUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchCoverageGetCoverageViewDocumentFileUrlQuery({
 *   ids: // value for 'ids'
 * });
 */
export function useSearchCoverageGetCoverageViewDocumentFileUrlQuery(variables: SearchCoverageGetCoverageViewDocumentFileUrlQueryVariables | VueCompositionApi.Ref<SearchCoverageGetCoverageViewDocumentFileUrlQueryVariables> | ReactiveFunction<SearchCoverageGetCoverageViewDocumentFileUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchCoverageGetCoverageViewDocumentFileUrlQuery, SearchCoverageGetCoverageViewDocumentFileUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchCoverageGetCoverageViewDocumentFileUrlQuery, SearchCoverageGetCoverageViewDocumentFileUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchCoverageGetCoverageViewDocumentFileUrlQuery, SearchCoverageGetCoverageViewDocumentFileUrlQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchCoverageGetCoverageViewDocumentFileUrlQuery, SearchCoverageGetCoverageViewDocumentFileUrlQueryVariables>(SearchCoverageGetCoverageViewDocumentFileUrlDocument, variables, options);
}
export function useSearchCoverageGetCoverageViewDocumentFileUrlLazyQuery(variables?: SearchCoverageGetCoverageViewDocumentFileUrlQueryVariables | VueCompositionApi.Ref<SearchCoverageGetCoverageViewDocumentFileUrlQueryVariables> | ReactiveFunction<SearchCoverageGetCoverageViewDocumentFileUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchCoverageGetCoverageViewDocumentFileUrlQuery, SearchCoverageGetCoverageViewDocumentFileUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchCoverageGetCoverageViewDocumentFileUrlQuery, SearchCoverageGetCoverageViewDocumentFileUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchCoverageGetCoverageViewDocumentFileUrlQuery, SearchCoverageGetCoverageViewDocumentFileUrlQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SearchCoverageGetCoverageViewDocumentFileUrlQuery, SearchCoverageGetCoverageViewDocumentFileUrlQueryVariables>(SearchCoverageGetCoverageViewDocumentFileUrlDocument, variables, options);
}
export type SearchCoverageGetCoverageViewDocumentFileUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchCoverageGetCoverageViewDocumentFileUrlQuery, SearchCoverageGetCoverageViewDocumentFileUrlQueryVariables>;